import React from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

const RANGE_PER_PAGES = 4 ;

const Paginator = React.forwardRef(({ className, rangePerPage,onPageChange,pageCount, actualPage ,...props}, ref) =>{

  return (
    <ReactPaginate
      pageCount={pageCount}
      previousLabel={'<'}
      nextLabel={'>'}
      breakLabel="..."
      breakClassName="break-me"
      marginPagesDisplayed={2}
      initialPage={actualPage}
      onPageChange={(page) => onPageChange(page)}
      pageRangeDisplayed={rangePerPage}
      containerClassName={`pagination ${className}`}
      activeClassName="active"
    />
  )

});

Paginator.displayName = 'Paginator';

Paginator.defaultProps = {
  className: '',
  pageCount:10,
  actualPage:1,
  rangePerPage: RANGE_PER_PAGES,
  onPageChange: ()=>{},
};

Paginator.propTypes = {
  onChange: PropTypes.func,
  type:  PropTypes.string,
  pageCount: PropTypes.number,
  actualPage: PropTypes.number,

};

export default Paginator;
